import React from "react"
import RolePermissionsImproved from "./RolePermissionsImproved"

const RoleForm = ({
  loading,
  error,
  role,
  onChangePermission,
  permissionResponse,
  groupedPermissions,
}) => {
  // Role Permission Component with improved UI
  return (
    <RolePermissionsImproved
      permissions={role?.permissions}
      loading={loading}
      onChangePermission={onChangePermission}
      permissionResponse={permissionResponse}
      activePermissions={role?.activePermissions}
      role={role}
      groupedPermissions={groupedPermissions}
      rightBtn={true}
      url={"/roles"}
    />
  )
}

export default RoleForm
